import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons'
import { useCallback } from 'react'
import TwinIcon from '../../TwinIcon'

interface CustomToolbarYearsProps extends CustomToolbarYearsLogicProps {
    year: number
    getData: () => void
}

const CustomToolbarYears: React.FC<CustomToolbarYearsProps> = ({ year, getData, ...rest }) => {
    const { handleNextYear, handlePrevYear } = useCustomToolbarYearsLogic({ ...rest })
    return (
        <div className='flex items-center custom_calendar_toolbar'>
            <div className='mr-24'>
                <TwinIcon className='cursor-pointer p-3 h-24  hover:text-green-21' icon={faChevronLeft} onClick={handlePrevYear} />
            </div>
            <div className='mr-24'>
                <TwinIcon className='cursor-pointer p-3 h-24 hover:text-green-21' icon={faChevronRight} onClick={handleNextYear} />
            </div>
            <div className='toolbar-label text-left text-gray-51 capitalize'>
                {year}
            </div>
        </div>
    )
}

interface CustomToolbarYearsLogicProps {
    setYear: React.Dispatch<React.SetStateAction<number>>
}

const useCustomToolbarYearsLogic = ({ setYear }: CustomToolbarYearsLogicProps) => {

    const handlePrevYear = useCallback(() => {
        setYear((old) => old - 1)
    }, [setYear])
    const handleNextYear = useCallback(() => {
        setYear((old) => old + 1)
    }, [setYear])

    return { handleNextYear, handlePrevYear }
}

export default CustomToolbarYears